import React from "react";

const SearchInput = ({ placeHolder, value, onChange }) => {
    return (
        <div style={{ alignSelf: "start"}}>
            <div className="form-group d-flex align-items-center flex-row-reverse position-relative">
                <input
                    type="text"
                    value={value}
                    onChange={onChange}
                    placeholder={placeHolder || "Search health centers..."}
                    className="form-control ps-2 bg-transparent border-0 shadow-none"
                />
                <button type="submit" className="p-0 bg-transparent border-0">
                    <span className="d-block material-symbols-outlined icon-lg">search</span>
                </button>
            </div>
        </div>
    );
};

export default SearchInput;